export const webhook = {
  field: {
    url: 'URI',
    type: 'Tipe'
  },
  
  button: {
    create: 'Buat webhook',
    disabled: 'The entire webhook was created'
  },

  input: {
    disabled: 'The entire webhook was created'
  },

  modal: {
    create: 'Buat webhook',
    edit: 'Edit webhook',
    remove: {
      content: 'Anda yakin ingin menghapus webhook {type}?'
    }
  },

  webhook_type: {
    call_interrupted: 'Panggilan interupsi',
    op_disconnected: 'Operator terputus',
    op_active: 'Operator aktif',
    op_inactive: 'Operator tidak aktif',
    call_restored: 'Panggilan dipulihkan',
    call_started: 'Panggilan dimulai',
    call_client_answered: 'Panggilan klien dijawab',
    call_failed: 'Panggilan gagal',
    call_finished: 'Panggilan selesai',
    task_success: 'Sukses tugas',
    task_failed: 'Tugas gagal',
    recording_ready: 'Siap merekam',
    op_deactivating: 'Operator menonaktifkan',
    call_connected: 'Panggilan terhubung',
    op_connected: 'Operator tersambung',
    amd_result: 'Deteksi mesin penjawab'
  }
}